import '../styles/style.css';
import { Link } from 'react-router-dom';
import React, { useMemo, useState, useEffect } from 'react';
import FilterComponent from './filterComponent';
import DataTable, { createTheme, Export, downloadCSV } from "react-data-table-component";
import { useSelector, useDispatch } from 'react-redux';
import { DeleteDocumentAction } from '../../actions/deleteDocument';
import { IndexAction } from '../../actions/IndexAction';
import { ButtonActionsFlag } from '../../actions/ButtonActionsFlag';
import pdf from '../../images/pdf-ref2.png'
import { StatisticId } from '../../actions/statisticsId';
import { ShowModalFlag } from '../../actions/showModalFlag';
import { EditFileAction } from '../../actions/EditFileAction';
import HamburgerMenu from './toolbar';
import ListButtons from './ListBar';
createTheme("solarized", {
    text: {
        primary: "#268bd2",
        secondary: "#2aa198"
    },
    background: {
        default: "#002b36"
    },
    context: {
        background: "#cb4b16",
        text: "#FFFFFF"
    },
    divider: {
        default: "#073642"
    },
    action: {
        button: "rgba(0,0,0,.54)",
        hover: "rgba(0,0,0,.08)",
        disabled: "rgba(0,0,0,.12)"
    }
});

export default function MyDocuments() {
    const [resetData, setResetData] = useState(null);
    const [myData, setMyData] = useState([]);
    const dispatch = useDispatch();
    const IndexReducer = useSelector(state => state.IndexReducer);
    const DeleteDocumentReducer = useSelector(state => state.DeleteDocumentReducer);
    const EditDocumentReducer = useSelector(state => state.EditDocumentPropReducer);
    const DeleteMoreThanOneDocumentReducer = useSelector(state => state.DeleteMoreThanOneDocumentReducer);
    const [renameDocumentActive, setRenameDocumentActive] = useState(false);
    const [flag, setFlag] = useState(false);
    const [isMobileView, setIsMobileView] = useState(false); // Ekran boyutuna göre ayarlama
    const newPdfSuccess = useSelector(state => state.newPdfRedux.last);
    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth < 990) {
                setIsMobileView(true);
            } else {
                setIsMobileView(false);
            }
        };

        // Ýlk yüklemede ve her yeniden boyutlandýrmada kontrol eder
        handleResize();
        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);
    useEffect(() => {
        if (!flag) {
            dispatch(IndexAction());
            setFlag(true);
        }
    }, []);


    useEffect(() => {
        if (newPdfSuccess == "SUCCESS") {
            dispatch(IndexAction());
        }
    }, [newPdfSuccess]);


    useEffect(() => {
        dispatch(IndexAction());
    }, [EditDocumentReducer]);

    useEffect(() => {

        setMyData([]);
        if (IndexReducer && IndexReducer.data && IndexReducer.data.isSuccessful) {
            setMyData(myData => [...myData, ...IndexReducer.data.data.rt]);
            //localStorage.setItem('myDocuments', JSON.stringify(IndexReducer.data.data.rt));
        }
    }, [IndexReducer]);

    useEffect(() => {
        if (DeleteDocumentReducer && DeleteDocumentReducer.data.isSuccessful) {
            dispatch(IndexAction());
        }
    }, [DeleteDocumentReducer]);

    const deleteDocument = (event) => {
        event.preventDefault();
        dispatch(DeleteDocumentAction(parseInt(event.currentTarget.id)))

    }

    useEffect(() => {
        if (DeleteMoreThanOneDocumentReducer && DeleteMoreThanOneDocumentReducer.data && DeleteMoreThanOneDocumentReducer.data.isSuccessful) {
            setResetData(DeleteMoreThanOneDocumentReducer.count);
        }
    }, [DeleteMoreThanOneDocumentReducer]);

    const onClickChanges = (data) => {
        if (resetData && resetData !== null) {
            data.selectedRows = data.selectedRows.slice(0, (-1 * resetData));
            data.selectedCount = data.selectedCount - resetData;
            setResetData(null);
        }
        if (data) {
            dispatch(ButtonActionsFlag(data));
        }
    }

    const onClickStatistics = (id, name) => {
        dispatch(StatisticId(id, name, true));
    }

    const Header1 = ({ n }) => <span><b>{n}</b></span>

    const renameClickEvent = (row) => {
        dispatch(ShowModalFlag("edit"));
        dispatch(EditFileAction(row))
    }

    const columns = [
        {
            name: "Actions",
            selector: (row) => (
                isMobileView ? <div className="btn-group-actions">
                    <div className="dropdown">
                        {/* Three-Dot Button */}
                        <button
                            className="btn btn-sm btn-success "
                            type="button"
                            style={{'width':'40px'} }
                            id={`dropdownMenuButton-${row.id}`}
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                            aria-label="Actions"
                        >
                            <i className="fa fa-ellipsis-v"></i>
                        </button>

                        {/* Dropdown Menu */}
                        <ul className="dropdown-menu" aria-labelledby={`dropdownMenuButton-${row.id}`}>
                            {/* View Action */}
                            <li>
                                <Link
                                    className="dropdown-item"
                                    to={{
                                        pathname: `/index/viewer/${row.id}`,
                                    }}
                                    target="_blank"
                                    state={{ id: row.id }}
                                    title="View"
                                >
                                    <i className="fa-regular fa-eye me-2"></i> View
                                </Link>
                            </li>

                            {/* Edit Action */}
                            <li>
                                <button
                                    className="dropdown-item"
                                    onClick={() => renameClickEvent(row.model)}
                                    title="Edit"
                                >
                                    <i className="fa-solid fa-pencil me-2"></i> Edit
                                </button>
                            </li>

                            {/* Statistics Action */}
                            <li>
                                <button
                                    className="dropdown-item"
                                    onClick={() => onClickStatistics(row.id, row.model.name)}
                                    title="Statistics"
                                >
                                    <i className="fa-regular fa-chart-bar me-2"></i> Statistics
                                </button>
                            </li>

                            {/* Share Action */}
                            <li>
                                <Link
                                    className="dropdown-item"
                                    to={{
                                        pathname: `/index/share/${row.id}`,
                                    }}
                                    target="_blank"
                                    state={{ id: row.id, data: row }}
                                    title="Share"
                                >
                                    <i className="fa fa-users me-2"></i> Share
                                </Link>
                            </li>

                            {/* Delete Action */}
                            <li>
                                <button
                                    className="dropdown-item text-danger"
                                    onClick={() => deleteDocument(row.id)}
                                    title="Delete"
                                >
                                    <i className="fa-solid fa-trash-can me-2"></i> Delete
                                </button>
                            </li>
                        </ul>
                    </div>
                </div> :
                <div className="btn-group-actions">
                    <Link className="text-success btn btn-sm btn-success text-white m-1" target="_blank" to={{
                        pathname: `/index/viewer/${row.id}`
                    }} state={{ id: row.id }} title="View">
                        <i style={{ color: 'white' }} className="fa-regular fa-eye"></i>
                    </Link>

                    <Link className="text-success btn btn-sm btn-primary text-white m-1" onClick={() => { renameClickEvent(row.model) }}
                       title="Edit">
                        <i style={{ color: 'white' }} className="fa-solid fa-pencil"></i>
                    </Link>

                    <div className="text-muted btn btn-sm btn-warning text-white m-1" onClick={() => { onClickStatistics(row.id, row.model.name) }} title="Statistics">
                        <i style={{ color: 'white' }} className="fa-regular fa-chart-bar"></i>
                    </div>
                    <Link className="text-primary btn btn-sm btn-info text-white m-1" target="_blank" to={{
                        pathname: `/index/share/${row.id}`,
                    }} state={{ id: row.id, data: row }}
                        title="Share">
                        <i className="fa fa-users"></i>
                    </Link>
                    <Link onClick={deleteDocument} id={row.id} className="text-danger btn btn-sm btn-danger text-white m-1" to="#" title="Delete">
                        <i className="fa-solid fa-trash-can"></i>
                    </Link>
                </div>

            ),
            minWidth: isMobileView ? "80px" :  "240px",

        }, {
            name: <Header1 n={'Name'} />,
            selector: (row) => row['model']['name'],
            cell: row => <div className="d-flex"><div style={{ alignItems: 'center', display: 'flex' }}><img style={{ marginRight: '10px' }} src={pdf} alt="pdf" width={25} height={25}></img></div><div>{row['model']['name']}</div></div>,//<br /> {row['model']['description']}
            sortable: true,
            minWidth: "350px",

        },
        {
            name: <Header1 n={'Description'} />,
            selector: (row) => row['model']['description'],
            sortable: true,
            minWidth: "300px",
            hide: 'sm',
            //grow:1
        },
        {
            name: <Header1 n={'Views'} />,
            selector: (row) => row.count,
            sortable: true,
            minWidth: "95px",
            center:true

        }, {
            name: <Header1 n={'Viewers'} />,
            selector: (row) => row.countReader,
            sortable: true,
            minWidth: "95px",
            center: true
        }, {
            name: <Header1 n={'# Pages'} />,
            selector: (row) => row['model']['totalPages'],
            sortable: true,
            minWidth: "95px",
            center: true
        },
        {
            name: "Created",
            selector: (row) => (
                row.model.createdAt.split('.')[0].replace('T', ' ')
            ),
            sortable: true,
            hide: 'sm',
            minWidth: "175px",
        },
        {
            name: "Updated",
            selector: (row) => (
                row.model.modifiedAt.split('.')[0].replace('T', ' ')
            ),
            sortable: true,
            hide: 'sm',
            minWidth: "175px",
        },
    ];
    ;
    const [filterText, setFilterText] = useState('');
    const [resetPaginationToggle, setResetPaginationToggle] = useState(false);

    const filteredItems = myData.filter(
        item =>
            JSON.stringify(item)
                .toLowerCase()
                .indexOf(filterText.toLowerCase()) !== -1
    );

    const subHeaderComponent = useMemo(() => {
        const handleClear = () => {
            if (filterText) {
                setResetPaginationToggle(!resetPaginationToggle);
                setFilterText("");
            }
        };

        return (
            <>
                <hr />
                <div className="buttonGroups">
                    <ListButtons show={true} data={"myDocuments"} />
                    <div className="zrtykLm">
                        <FilterComponent
                            onFilter={e => setFilterText(e.target.value)}
                            onClear={handleClear}
                            filterText={filterText}
                        />
                        <HamburgerMenu data={filteredItems} type={"myDocuments"} />
                    </div>
                </div>
            </>
        );
    }, [filterText, resetPaginationToggle, myData]);

    const customPagination = {
        selectAllRowsItem : true,
        selectAllRowsItemText : "All",
    }
    const tableCustomStyles = {
        table: {
            style: {
                borderCollapse: 'collapse',
            },
        },
        headRow: {
            style: {
                color: '#223336',
                //backgroundColor: '#e7eef0',
            },
        }, 
    }

    return (
        <div className="App mb-5">
            <DataTable
                columns={columns}
                customStyles={tableCustomStyles}
                data={filteredItems}
                pagination
                paginationComponentOptions={customPagination}
                highlightOnHover
                striped
                responsive={true}
                defaultSortFieldId={7}
                defaultSortAsc={false}
                paginationPerPage={30}
                subHeader
                subHeaderComponent={subHeaderComponent}
                selectableRows
                selectableRowsOnClick
                onSelectedRowsChange={onClickChanges}
            />
        </div>
    );
}
